import { render, staticRenderFns } from "./EditInstitution.vue?vue&type=template&id=286f6972&scoped=true"
import script from "./EditInstitution.vue?vue&type=script&lang=js"
export * from "./EditInstitution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286f6972",
  null
  
)

export default component.exports